export default {
    calcular: function (dados, campos, campoFuncao, ignorarFuncoes, somenteNumeros) {

        //console.trace();

        var _camposFuncao = campoFuncao ? [campoFuncao] : campos.filter(e => e.campoFuncao)
        // ordena os campos função para que não haja referência a um campo que ainda não foi calculado
        _camposFuncao = this.ordenaCamposFuncao(_camposFuncao)

        const sortAsc = (a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        }
        const sortDesc = (a, b) => {
            if (a > b) return -1;
            if (a < b) return 1;
            return 0;
        }

        var _cache = {}
        campos.forEach(c => {
            _cache[c.campo] = {}
        })

        const executaFuncao = function (posReg, funcaoCampo, camposExpressaoCache) {

            let _this = this;
            const fazCalculo = (valorExpressao) => {
                //Tira as quebras de linha
                valorExpressao = valorExpressao.replaceAll('\n', '')
                var results = null

                if (!ignorarFuncoes) {
                    results = valorExpressao.match(/((Acumular|RankAsc|RankDesc|Sum|Avg|Max|Min|Count)\s*\(\s*\[\s*(.+?)\s*\]\s*\))/gimu)
                    if (results) {
                        results.forEach(match => {
                            let func = /(Acumular|RankAsc|RankDesc|Sum|Avg|Max|Min|Count)\s*\(\s*\[\s*(.+?)\s*\]\s*\)/gimu.exec(match);
                            let campoFunc = func[2]
                            let funcao = func[1].toLowerCase()
                            let _valor = 0;
                            switch (funcao) {
                                case "acumular":
                                    _valor = dados[posReg][campoFunc];
                                    if (posReg > 0)
                                        _valor += dados[posReg - 1][campo.campo];
                                    break;
                                case "rankasc":
                                    if (dados[posReg][campoFunc] != undefined) {
                                        if (!_cache[campoFunc][funcao]) {
                                            // usa cache pra lista ordenada
                                            _cache[campoFunc][funcao] = Array.from(new Set(dados.filter(e => e[campoFunc] != undefined).map(function (e) {
                                                return e[campoFunc];
                                            }).sort(sortAsc)))
                                        }
                                        _valor = _cache[campoFunc][funcao].indexOf(dados[posReg][campoFunc]) + 1
                                    } else {
                                        // Valores vazios devem ficar sem rank
                                        _valor = undefined
                                    }
                                    break;
                                case "rankdesc":
                                    if (dados[posReg][campoFunc] != undefined) {
                                        if (!_cache[campoFunc][funcao]) {
                                            // usa cache pra lista ordenada
                                            _cache[campoFunc][funcao] = Array.from(new Set(dados.filter(e => e[campoFunc] != undefined).map(function (e) {
                                                return e[campoFunc];
                                            }).sort(sortDesc)))
                                        }
                                        _valor = _cache[campoFunc][funcao].indexOf(dados[posReg][campoFunc]) + 1
                                    } else {
                                        // Valores vazios devem ficar sem rank
                                        _valor = undefined
                                    }
                                    break;
                                case "sum":
                                case "avg":
                                case "min":
                                case "max":
                                case "count":
                                    if (_cache[campoFunc][funcao]) {
                                        _valor = _cache[campoFunc][funcao]
                                    } else {
                                        switch (funcao) {
                                            case "sum":
                                                _valor = dados.reduce(function (a, b) {
                                                    return b[campoFunc] == null ? a : a + b[campoFunc];
                                                }, 0);
                                                break;
                                            case "avg":
                                                _valor = dados.reduce(function (a, b) {
                                                    return b[campoFunc] == null ? a : a + b[campoFunc];
                                                }, 0) / dados.length;
                                                break;
                                            case "min":
                                                _valor = dados.reduce(function (a, b) {
                                                    return a == null ? b[campoFunc] : (b[campoFunc] == null ? a : (a > b[campoFunc] ? b[campoFunc] : a));
                                                }, null);
                                                break;
                                            case "max":
                                                _valor = dados.reduce(function (a, b) {
                                                    return a == null ? b[campoFunc] : (b[campoFunc] == null ? a : (a < b[campoFunc] ? b[campoFunc] : a));
                                                }, null);
                                                break;
                                            case "count":
                                                let dadosColuna = dados.map(d => d[campoFunc])
                                                _valor = dadosColuna.filter(function (item, i) {
                                                    return i == dadosColuna.indexOf(item);
                                                }).length;
                                                break;
                                                break;
                                        }
                                        _cache[campoFunc][funcao] = _valor
                                    }
                            }
                            valorExpressao = valorExpressao.replace(match, _valor)
                        })
                    }

                    results = valorExpressao.match(/(Count\s*\(\s*\))/gimu)
                    if (results) {
                        results.forEach(match => {
                            valorExpressao = valorExpressao.replace(match, dados.length)
                        })
                    }

                    results = valorExpressao.match(/(Lookup\s*\(\s*\[\s*(.+?)\s*\]\s*(,\s*(-*\s*\d+)\s*)*\))/gimu)
                    if (results) {
                        results.forEach(match => {
                            let func = /Lookup\s*\(\s*\[\s*(.+?)\s*\]\s*(,\s*(-*\s*\d+)\s*)*\)/gimu.exec(match);
                            let campoFunc = func[1]
                            let posRegLk = posReg + parseInt(func[3] || '-1')
                            if (posRegLk >= 0 && posRegLk < dados.length) {
                                valorExpressao = valorExpressao.replace(func[0], dados[posRegLk][campoFunc]);
                            } else {
                                valorExpressao = valorExpressao.replace(func[0], ["DOUBLE", "INTEGER"].find(tipo => tipo === campos.find(c => !!c.campo && c.campo.toLowerCase() === campoFunc.toLowerCase()).tipo) ? 0 : '');
                            }
                        })
                    }
                }

                let camposExpressao = valorExpressao.match(/\[[\w\d]+\]/gmiu)

                if (!camposExpressaoCache) {
                    camposExpressaoCache = campos.filter(c => {
                        if (camposExpressao)
                            return (!!c.campo && !!camposExpressao.includes(`[${c.campo}]`))
                        else
                            return !!c.campo
                    })
                }
                //aqui subistituir os campos. ex.: [valor]
                for (let i = 0; i < camposExpressaoCache.length; i++) {
                    let campoExpressao = camposExpressaoCache[i]
                    let campo = Object.keys(dados[posReg]).find(cd => cd.toLowerCase() == campoExpressao.campo.toLowerCase()) || campoExpressao.campo
                    let substituir = `'${dados[posReg][campo]}'`
                    switch (campoExpressao.tipo) {
                        case "DOUBLE":
                        case "INTEGER":
                            substituir = `(${dados[posReg][campo]})`; // adiciona parênteses pra evitar erro 1--2
                            break;
                        case "DATE":
                        case "TIME":
                        case "DATETIME":
                            valorExpressao = valorExpressao.replaceAll('\"', '')
                            substituir = `new Date('${dados[posReg][campo]}')`
                            break;
                        case "BOOLEAN":
                            substituir = dados[posReg][campo]
                            break;
                    }
                    valorExpressao = valorExpressao.replace(new RegExp(`\\[\\s*(${campoExpressao.campo}?)\\s*\\]`, 'gimu'), substituir);
                }
                
                // Regex para capturar todas as funções Coalesce
                const coalescePattern = /Coalesce\s*\(\s*([^,]+?)\s*,\s*(.*?)\s*\)/gi;

                const extractCoalesce = (str) => {
                    const matches = [];
                    let match;
                    while ((match = coalescePattern.exec(str)) !== null) {
                        matches.push(match[0]);
                    }
                    return matches;
                };

                const parseCoalesce = (expression) => {
                    const regex = /Coalesce\s*\(\s*(.*?),\s*(.*?)\)$/i;
                    const match = expression.match(regex);

                    if (!match) return null;

                    let funcao = match[0];
                    let calcInterno = match[1];
                    let substituto = match[2];

                    // Verifique se há parênteses balanceados em calcInterno
                    let openParen = 0;
                    for (let i = 0; i < calcInterno.length; i++) {
                        if (calcInterno[i] === '(') openParen++;
                        if (calcInterno[i] === ')') openParen--;
                    }

                    // Se os parênteses não estiverem equilibrados
                    while (openParen !== 0) {
                        const nextMatch = regex.exec(expression.slice(funcao.length));
                        if (!nextMatch) break;
                        calcInterno += ',' + nextMatch[1];
                        substituto = nextMatch[2];
                        openParen = 0;
                        for (let i = 0; i < calcInterno.length; i++) {
                            if (calcInterno[i] === '(') openParen++;
                            if (calcInterno[i] === ')') openParen--;
                        }
                    }

                    return {
                        funcao,
                        calcInterno,
                        substituto
                    };
                };

                // Extraia todas as funções Coalesce
                const coalesceFunctions = extractCoalesce(valorExpressao);

                // Passe cada função Coalesce para o parseCoalesce
                let coalesceParsed;
                coalesceFunctions.forEach(coalesce => {
                    coalesceParsed = parseCoalesce(coalesce);
                    results = coalesceParsed != null ? [coalesceParsed.funcao] : null;
                    if (results) {
                        results.forEach(match => {
                            let { funcao, calcInterno, substituto }= parseCoalesce(match);
                            let valor = null
                            try {
                                valor = fazCalculo(calcInterno)
                            } catch {
                            }
                            if (typeof valor === 'string') {
                                let valorComparacao = valor.replaceAll('\'', '')
                                valorExpressao = valorExpressao.replace(match, ((valorComparacao == undefined || valorComparacao === '' || valorComparacao == null || valorComparacao == 'null' || valorComparacao == 'undefined') ? substituto : valor) || substituto);
                            } else
                                valorExpressao = valorExpressao.replace(match, ((valor === Infinity || valor === -Infinity) ? substituto : valor) || substituto)
                        })
                    }
                });
                // results = coalesceParsed != null ? [coalesceParsed.funcao] : null;

                //sanitiza pra não ter comandos maliciosos ou inválidos
                var evalSanitized = (expressao, condicao) => {
                    let match = somenteNumeros
                        ? expressao.match(/(([-/+*.(),><=\d\s])|and|or|parseFloat|new Date\(.*\)|Math.min|Math.max|Math.abs)|\|\|/gimu)
                        : expressao.match(/(('(.*?)')|("(.*?)")|([-/+*.(),><=\d\s])|and|or|parseFloat|new Date\(.*\)|Math.min|Math.max|Math.abs)|\|\|/gimu)
                    let valorExpress = match?.join('')
                    sanitized = valorExpress != expressao
                    if (condicao) {
                        [
                            {original: 'AND', substituto: '&&'},
                            {original: 'OR', substituto: '||'},
                            {original: '<>', substituto: '!='},
                            {original: '=', substituto: '=='}
                        ].forEach(op => {
                            //substitui os operadores "amigáveis" pelos operadores javascript
                            valorExpress = valorExpress
                                .replace(new RegExp(`(?<=^([^']|'[^']*')*[^><]+)(?<=^([^"]|"[^"]*")*[^><]+)(?<=["' ]?)(?<!${op.original})(${op.original})(?!${op.original})`, 'gi'), op.substituto)
                        })
                    }
                    var funcaoEval = new Function("return " + valorExpress)
                    if (!condicao && valorExpress.match(/([\'|\"])/))
                        return `'${funcaoEval()}'`;
                    return funcaoEval()
                }
                const regexSe = '(?<funcao>if)\\s*\\((\\s*(?<condicao>.*?)\\s*;\\s*(?<verdadeiro>.*?)\\s*;\\s*(?<falso>.*)\\))'
                results = valorExpressao.match(new RegExp(regexSe, 'gimu'))
                if (results) {
                    results.forEach(match => {
                        var {groups: {funcao, condicao, verdadeiro, falso}} = (new RegExp(regexSe, 'gimu')).exec(match)
                        const condicaoVerdadeira = evalSanitized(condicao, true)
                        if (condicaoVerdadeira)
                            valorExpressao = valorExpressao.replace(match, verdadeiro)
                        else {
                            try {
                                valorExpressao = valorExpressao.replace(match, fazCalculo(falso))
                            } catch {
                            }
                        }
                    })
                }
                results = valorExpressao.match(/((ToDouble)\s*\(.*?\))/gimu)
                if (results) {
                    results.forEach(regEx => {
                        valorExpressao = valorExpressao.replace(/ToDouble/gimu, "parseFloat");
                    })
                }

                results = valorExpressao.match(/(Max2|Min2|Abs)\s*\(/gimu)
                if (results) {
                    results.forEach(match => {
                        let func = /(Max2|Min2|Abs)/gimu.exec(match);
                        let funcao = func[1].toLowerCase()
                        switch (funcao) {
                            case 'min2':
                                valorExpressao = valorExpressao.replace(func[1], 'Math.min')
                                break;
                            case 'max2':
                                valorExpressao = valorExpressao.replace(func[1], 'Math.max')
                                break;
                            case 'abs':
                                valorExpressao = valorExpressao.replace(func[1], 'Math.abs')
                                break;
                        }
                    })
                }

                return evalSanitized(valorExpressao)
            }

            try {
                //console.log('funcaoCampo:', funcaoCampo)
                let dado = fazCalculo(funcaoCampo)
                dados[posReg][campo.campo] = typeof dado === 'string' ? dado.replaceAll('\'', '') : dado

                // Infinity ou NaN deixa vazio
                if (dados[posReg][campo.campo] === Infinity || dados[posReg][campo.campo] === -Infinity || (["DOUBLE", "INTEGER"].includes(campo.tipo) && isNaN(dados[posReg][campo.campo]))) {
                    dados[posReg][campo.campo] = null
                }
            } catch (ex) {
                //console.error("CAMPO:", campo.campo, "EXPRESSÃO:", funcaoCampo, "ERRO:", ex.message);
                erro = true
                mensagem = ex.message
            }
        }

        let erro = false
        let mensagem = ''
        var sanitized = false
        try {
            for (var campo of _camposFuncao) {
                let camposExpressaoCache = undefined
                for (var posReg = 0; posReg < dados.length; posReg++)
                    executaFuncao(posReg, campo.funcao, camposExpressaoCache);
            }
            _cache = {}
        } catch (ex) {
            console.log(ex.message);
            erro = true
            mensagem = ex.message
        }

        return {
            dados,
            erro,
            mensagem,
            sanitized
        }
    },
    ordenaCamposFuncao: (camposFuncao) => {
        const tsort = (edges) => {
                let nodes = {}, sorted = [], visited = {};

                let Node = function (id) {
                    this.id = id;
                    this.afters = [];
                }

                edges.forEach((v) => {
                    let from = v[0], to = v[1];
                    if (!nodes[from]) nodes[from] = new Node(from);
                    if (!nodes[to]) nodes[to] = new Node(to);
                    nodes[from].afters.push(to);
                });

                Object.keys(nodes).forEach(function visit(idstr, ancestors) {
                    let node = nodes[idstr], id = node.id;

                    if (visited[idstr]) return;
                    if (!Array.isArray(ancestors)) ancestors = [];

                    ancestors.push(id);
                    visited[idstr] = true;
                    node.afters.forEach(function (afterID) {
                        if (ancestors.indexOf(afterID) >= 0)
                            throw new Error('closed chain : ' + afterID + ' is in ' + id);
                        visit(afterID.toString(), ancestors.map(function (v) {
                            return v
                        }));
                    });
                    sorted.unshift(id);
                });

                return sorted;
            },
            getMatches = (string, regex, index) => {
                index || (index = 1); // default to the first capturing group
                var matches = [];
                var match;
                while (match = regex.exec(string)) {
                    matches.push(match[index]);
                }
                return matches;
            },
            createEdges = (campos) => {
                let result = []
                campos.forEach(campo => {
                    const camposFormula = getMatches(campo.funcao, /\s*\[\s*(.+?)\s*\]\s*/gimu) || []
                    camposFormula.forEach(cf => {
                        result.push([cf, campo.campo])
                    })
                })
                return result
            }

        let camposEmOrdem = tsort(createEdges(camposFuncao))
        return camposFuncao.sort((a, b) => {
            if (camposEmOrdem.indexOf(a.campo) < camposEmOrdem.indexOf(b.campo)) return -1
            if (camposEmOrdem.indexOf(a.campo) > camposEmOrdem.indexOf(b.campo)) return 1
            return 0
        })
    },
    validar: function (campos, formula, ignorarFuncoes, somenteNumeros) {
        let campo = {
            campo: 'calculado',
            campoFuncao: true,
            funcao: formula.replaceAll('\n', '')
        }
        let dados = [{}, {}]
        let isDateValid = true
        for (let i = 0; i < 2; i++) {
            campos.forEach(c => {
                if (["DOUBLE", "INTEGER"].find(tipo => tipo === c.tipo))
                    dados[i][c.campo] = 1
                else {
                    // Se for do tipo TIME O valor do campo expressao deve estar no formato "HH:mm:ss".
                    //A e deve contem ASPAS.
                    if (c.tipo === 'TIME') {
                        const regexHorasMinutos = /^'([01]\d|2[0-3]):([0-5]\d)\s*'$/;
                        const regexHorasMinutosSegundos = /^'([01]\d|2[0-3]):([0-5]\d):([0-5]\d)'\s*$/;
                        let regex;
                        if (c.formatacao.type == 'hour' || c.formatacao.type == 'shortTime') {
                            regex = regexHorasMinutos;
                        } else if (c.formatacao.type == 'longTime') {
                            regex = regexHorasMinutosSegundos;
                        }
                        if (!regex?.test(c?.funcao))
                            isDateValid = false;
                    }
                    dados[i][c.campo] = 'a'
                }
            })
        }

        let resultado = this.calcular(dados, campos, campo, ignorarFuncoes, somenteNumeros)
        if (!isDateValid)
            resultado.erro = true
        return !resultado.erro && !resultado.sanitized
    }
}